export default "__VITE_ASSET__e2ca0e42__"